export default __webpack_public_path__ + "app/images/common/linshare-logo-white.png";